// (100% - (SLIDES_COUNT -1) * GAP) / SLIDES_COUNT * SIZE + (SIZE - 1) * GAP
export function calculateSlideFlex(size: number = 1) {
  // eslint-disable-next-line max-len
  return `0 0 calc((100% - (var(--carousel-slides-per-view) - 1) * var(--carousel-slides-gap)) / var(--carousel-slides-per-view) * ${size} + ${size - 1} * var(--carousel-slides-gap))`;
}
